export default "__VITE_ASSET__oDnNOGv4__"